import type { AtlasDebugAppAdapter } from '../../shared/visual-atlas/debug';

export const aboutWebAtlasDebugAdapter: AtlasDebugAppAdapter = {
  appId: 'about-web',
};
